<div class="countrysnapshotsection__wrapper" *ngIf="section?.content || isHolidays" [class.is-header]="isHeader">
  <h3 class="countrysnapshotsection__header" *ngIf="previousSectionHeader">{{ previousSectionHeader }}</h3>
  <h3 class="countrysnapshotsection__title">{{ section?.name }}<ng-container *ngIf="isHolidays"> ({{ currentYear }})</ng-container></h3>
  <div *ngIf="!isHolidays else holidays" class="countrysnapshotsection__content" [innerHTML]="section?.content"></div>
  <ng-template #holidays>
    <ng-container *ngTemplateOutlet="holidayList; context: { $implicit: holidays$ | async }"></ng-container>
    <ng-container *ngIf="showNextYearHolidays">
      <h3 class="countrysnapshotsection__title">{{ section?.name }} ({{ currentYear+1 }})</h3>
      <ng-container *ngTemplateOutlet="holidayList; context: { $implicit: nextYearHolidays$ | async }"></ng-container>
    </ng-container>
  </ng-template>
  <!-- A year can have none: Calendarific lists Ukraine's holidays as suspended under martial law -->
  <ng-template #holidayList let-items>
    <ul *ngIf="items?.length; else noHolidays">
      <li *ngFor="let event of items" class="countrysnapshotsection__holiday">{{ event?.date|date:'MMMM d' }} - {{ event?.name }}</li>
    </ul>
    <ng-template #noHolidays>
      <p *ngIf="items" class="countrysnapshotsection__no-holidays">No holidays found</p>
    </ng-template>
  </ng-template>
</div>

